<template>
  <div class="contenedor-difusion">
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Inscripción Examen de Certificación Nivel 1</h1>
        <div class="barra"></div>
      </div>
      <section class="contenedor-login">
        <div class="contenedor-inscripcion-examen-text">
          <img src="@/assets/bksIyengarTeachingYoga.jpg" alt="Guruji">
        <p>Se encuentra abierta la inscripción para las mesas de Certificación Nivel 1, organizadas por la Asociación Argentina de Yoga Iyengar.</p>

        <p>📅 <b>Fechas:</b> 14 y 15 de noviembre de 2026</p>

        <p>📍 <b>Lugar:</b> CABA y GBA (a definir más adelante)</p>

        <p>🔸 La inscripción estará abierta hasta el 7 de septiembre de 2026 y el pago debe concretarse hasta el 7 de septiembre de 2026 SIN EXCEPCIÓN.</p>

        <p>Para concretar la inscripción es necesario completar los siguientes pasos:</p>

        <ul class="lista_requisitos_examenes">
          <li>⚬ Llenar la solicitud de inscripción</li>
          <li>⚬ Abonar el derecho de examen</li>
        </ul>

        <p>Por su parte, el mentor/a de cada aspirante deberá enviar al <b>Comité de Mentorías y Certificación (CMC)</b> la carta de recomendación correspondiente.</p>

        <p>💰 <b>Precio:</b> $300.000</p>

        <p>Las mesas de exámenes están abiertas a todos los candidatos que reúnan los requisitos, rindan por primera vez o que hayan rendido con anterioridad.</p>

        <p>⚠️ <b>Importante:</b> Una vez abonado el examen, en caso de no poder participar la Asociación NO devuelve el dinero. <br>Una vez que se haya concretado la inscripción con el pago, se les enviara el cuestionario que deberá ser entregado completo hasta el <b>24 de Octubre</b>.</p>

        <p class="email_examen">Ante cualquier duda, comunicarse con el <b>Comité de Mentorías y Certificación (CMC)</b> a:
                <a href="mailto:comitedecertificacion@asociacioniyengar.com.ar" target="_blank">comitedecertificacion@asociacioniyengar.com.ar</a></p>
        </div>
        <div class="contenedor-inscripcion-examen-form">
          <BaseLoader
            v-if="cargando"
          />
          <div v-else>
            <p class="seminario-texto-box" v-if="mostrarYaEstasInscripto">Ya estas inscripto en el examen</p>
            <p class="warning_no_socio" v-if="mostrarInscripcionCompleta">El cupo a las inscripciones se ha completado, te pedimos que tu mentor se comunique con el CMC para evaluar la situación.</p>
            <p class="warning_no_socio" v-if="mostrarInscripcionCerrada">Las inscripciones se encuentran cerradas</p>
            <p class="warning_no_socio" v-if="mostrarCupoCompletoPorMentor">El cupo de cuatro postulantes se ha completado para tu mentor, te pedimos que tu mentor se comunique con el Comité Técnico para evaluar la situación.</p>
            <div v-if="mostrarForm">
              <p class="titulo_form_inscripciones">Por favor completar todas las preguntas de la solicitud de inscripción</p>
              <form
                action="#"
                method="post"
                @submit.prevent="inscripcionExamen(respuestas)"
                class="form_editar_socio"
              >
              <div class="form_inscripcion_examen">
                <label for="edad">Edad</label>
                <input
                  type="text"
                  name="edad"
                  id="edad"
                  v-model="respuestas.edad"
                  :disabled="cargando"
                >
                <div
                class="form_inscripcion_seminario_error"
                  v-if="errores.edad !== null"
                >
                  {{ errores.edad[0] }}
                </div>
              </div>
              <div class="form_inscripcion_examen">
                <label for="toma_clase_regular">Nombre de tu profesor regular</label>
                <div class="contenedor_select_buscador">
                  <v-select
                    class="select_buscador minimal"
                    v-model.number="respuestas.toma_clase_regular"
                    label="item_data"
                    :reduce="profesores => profesores.persona_id"
                    :options="profesores"
                  >
                    <span slot="no-options" @click="$refs.select.open = false" class="select_buscador_warning">
                      <p>El profe ingresado no figura en nuestros registros.</p>
                    </span>
                  </v-select>
                </div>
                <div
                class="form_inscripcion_seminario_error"
                  v-if="errores.toma_clase_regular !== null"
                >
                  {{ errores.toma_clase_regular[0] }}
                </div>
              </div>
              <div class="form_inscripcion_examen">
                <label for="years">¿Años de práctica regular de Yoga Iyengar?</label>
                <input
                  type="text"
                  name="years"
                  id="years"
                  v-model="respuestas.years"
                  :disabled="cargando"
                >
                <div
                class="form_inscripcion_seminario_error"
                  v-if="errores.years !== null"
                >
                  {{ errores.years[0] }}
                </div>
              </div>
              <div class="form_inscripcion_examen">
                <label for="frecuencia_clases_tomadas">¿Cuántas clases por semana toma?</label>
                <input
                  type="text"
                  name="frecuencia_clases_tomadas"
                  id="frecuencia_clases_tomadas"
                  v-model="respuestas.frecuencia_clases_tomadas"
                  :disabled="cargando"
                >
                <div
                class="form_inscripcion_seminario_error"
                  v-if="errores.frecuencia_clases_tomadas !== null"
                >
                  {{ errores.frecuencia_clases_tomadas[0] }}
                </div>
              </div>
              <div class="form_inscripcion_examen">
                <label for="toma_clase_mentoria">Nombre de tu profesor mentor</label>
                <div class="contenedor_select_buscador">
                  <v-select
                    class="select_buscador minimal"
                    v-model.number="respuestas.toma_clase_mentoria"
                    label="item_data"
                    :reduce="profesoresMentores => profesoresMentores.persona_id"
                    :options="profesoresMentores"
                  >
                    <span slot="no-options" @click="$refs.select.open = false" class="select_buscador_warning">
                      <p>El profe ingresado no figura en nuestros registros.</p>
                    </span>
                  </v-select>
                </div>
                <div
                class="form_inscripcion_seminario_error"
                  v-if="errores.toma_clase_mentoria !== null"
                >
                  {{ errores.toma_clase_mentoria[0] }}
                </div>
              </div>
              <div class="form_inscripcion_examen">
                <label for="mentoria">Fecha de inicio/registro en mentoría</label>
                <input
                  type="text"
                  name="mentoria"
                  id="mentoria"
                  v-model="respuestas.mentoria"
                  :disabled="cargando"
                >
                <div
                class="form_inscripcion_seminario_error"
                  v-if="errores.mentoria !== null"
                >
                  {{ errores.mentoria[0] }}
                </div>
              </div>
              <div class="form_inscripcion_examen">
                <label for="dni">¿Es la primera vez que aplica a este nivel?</label>
                <input
                  type="text"
                  name="reincidencia"
                  id="reincidencia"
                  v-model="respuestas.reincidencia"
                  :disabled="cargando"
                >
                <div
                class="form_inscripcion_seminario_error"
                  v-if="errores.reincidencia !== null"
                >
                  {{ errores.reincidencia[0] }}
                </div>
              </div>
              <div class="form_inscripcion_examen">
                <label for="da_clases">¿Enseñas actualmente? ¿Cuántas clases por semana?</label>
                <input
                  type="text"
                  name="da_clases"
                  id="da_clases"
                  v-model="respuestas.da_clases"
                  :disabled="cargando"
                >
                <div
                class="form_inscripcion_seminario_error"
                  v-if="errores.da_clases !== null"
                >
                  {{ errores.da_clases[0] }}
                </div>
              </div>
              <div class="form_inscripcion_examen">
                <label for="lesiones">¿Tiene alguna lesión o condición?</label>
                <input
                  type="text"
                  name="lesiones"
                  id="lesiones"
                  v-model="respuestas.lesiones"
                  :disabled="cargando"
                >
                <div
                class="form_inscripcion_seminario_error"
                  v-if="errores.lesiones !== null"
                >
                  {{ errores.lesiones[0] }}
                </div>
              </div>
              <div class="form_inscripcion_examen">
                <label for="comentarios">Comentarios u observaciones</label>
                <textarea
                  name="comentarios"
                  id="comentarios"
                  v-model="respuestas.comentarios"
                  :disabled="cargando"
                ></textarea>
              </div>
              <div class="contenedor_checkbox">
                <input
                  type="checkbox"
                  id="form"
                  v-model="checkbox"
                >
                <label for="form">Estoy de acuerdo con los términos y condiciones anteriores y confirmo que toda la información es verídica.</label>
              </div>
              <p class="terminos_condiciones_mensaje_error" v-if="mostrarMensajeFormulario">Por favor acepta los términos y condiciones</p>
              <p v-if="mostrarNoDireccion" class="terminos_condiciones_mensaje_error">Por favor completa el domicilio en tu perfil para poder realizar tu pago</p>
              <button type="submit">Enviar respuestas y Pagar</button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>
<script src="https://unpkg.com/vue@2"></script>
<script src="https://unpkg.com/vue-select@latest"></script>
<script>
import 'vue-select/dist/vue-select.css';
import store from './../store'
import BaseLoader from '../components/BaseLoader.vue'
import asociadoService from '../services/asociado'
import mentorService from '../services/mentor'
import personasService from '../services/personas'
const mercadopago = require('mercadopago')
export default {
  name: 'IncripcionExamenNivel1',
  components: {
    BaseLoader
  },
  data: function () {
    return {
      cargando: false,
      checkbox: false,
      servicio_id: 32,
      cuota_id: 83,
      profesores: [],
      profesoresMentores: [],
      mostrarMensajeFormulario: false,
      mostrarNoDireccion: false,
      mostrarYaEstasInscripto: false,
      mostrarInscripcionCompleta: false,
      mostrarInscripcionCerrada: false,
      mostrarCupoCompletoPorMentor: false,
      mostrarForm: false,
      socio: [],
      respuestas: {
        edad: null,
        certificacion_id: 2, // Corresponde a Nivel 1
        reincidencia: null,
        toma_clase_regular: null,
        toma_clase_mentoria: null,
        frecuencia_clases_tomadas: null,
        da_clases: null,
        mentoria: null,
        lesiones: null,
        years: null,
        comentarios: null
      },
      errores: {
        edad: null,
        reincidencia: null,
        toma_clase_regular: null,
        toma_clase_mentoria: null,
        frecuencia_clases_tomadas: null,
        da_clases: null,
        mentoria: null,
        lesiones: null,
        years: null
      },
      linkMercadoPago: {
        link: null
      },
      user: {
        tipo_id: JSON.parse(localStorage.getItem('userData')).tipo_id,
        perfil_id: JSON.parse(localStorage.getItem('userData')).perfil_id,
        persona_id: JSON.parse(localStorage.getItem('userData')).persona_id,
        nombre: JSON.parse(localStorage.getItem('userData')).nombre,
        apellido: JSON.parse(localStorage.getItem('userData')).apellido,
        dni: JSON.parse(localStorage.getItem('userData')).dni,
        direccion_1: JSON.parse(localStorage.getItem('userData')).direccion_1,
        provincia_id_1: JSON.parse(localStorage.getItem('userData')).provincia_id_1
      }
    }
  },
  methods: {
    inscripcionExamen (respuestas) {
      console.log(respuestas)
      if (this.checkbox === false) {
        this.mostrarMensajeFormulario = true
      } else if (this.socio.dni == null || this.socio.direccion_1 == null || this.socio.ciudad_1 == null || this.socio.provincia_id_1 == null || this.socio.pais_id_1 == null) {
        this.mostrarNoDireccion = true
      } else {
        this.mostrarMensajeFormulario = false
        console.log('tildado')
        personasService
          .inscripcionExamen(respuestas)
          .then(respuesta => {
            this.cargando = false
            if (respuesta.success) {
              console.log('todos los campos llenos')
              const preference = {
                // trackingId: 77,
                back_urls: {
                  failure: 'https://portal.asociacioniyengar.com.ar/#/pago-rechazado',
                  success: 'https://portal.asociacioniyengar.com.ar/#/pago-exitoso'
                },
                items: [
                  {
                    title: 'Derecho a Examen 2026 (Noviembre)',
                    unit_price: 300000,
                    // unit_price: 2,
                    quantity: 1
                  }
                ],
                metadata: {
                  persona_id: this.socio.persona_id,
                  nombre: this.socio.nombre,
                  apellido: this.socio.apellido,
                  email: this.socio.email,
                  direccion: this.socio.direccion_1,
                  provincia: this.socio.provincia_id_1,
                  dni: this.socio.dni,
                  concepto_id: 3,
                  forma_de_pago_id: 3,
                  modo_de_pago_id: 1,
                  moneda_id: 1,
                  servicio_id: this.servicio_id,
                  cuota_id: this.cuota_id,
                  fecha_examen: '2026-11-14',
                  pago_concepto: 'Derecho a Examen 2026 (Noviembre)',
                  descripcion:  'Derecho a Examen 2026 (Noviembre)',
                  precio: 300000,
                  // precio: 2,
                  respuestas: Array(this.respuestas)
                },
                payer: {
                  name: this.socio.nombre,
                  surname: this.socio.apellido
                },
                notification_url: 'https://api.asociacioniyengar.com.ar/api/webhooks-examen',
                // notification_url: 'https://0bcc-2800-2206-6000-4d8-b9ad-b212-38a7-96af.ngrok-free.app/AAYI_API/api/public/api/webhooks-examen',
                binary_mode: true,
                auto_return: 'approved',
                external_reference: this.socio.nombre + ' ' + this.socio.apellido + ' - ' + new Date().getTime().toString(),
                statement_descriptor: 'Asociación Argentina de Yoga Iyengar'
              }
              mercadopago.configure({
                access_token: 'APP_USR-6447832264591121-032711-ad6690b0c38d8e10440c46daab8b7204-1323684790'
                // Credenciales de Prueba
                // access_token: 'APP_USR-2339860730955398-032713-925884898e35a8f3be76c84328e45b4f-1339687465'
              })
              mercadopago.preferences
                .create(preference)
                .then(response => {
                  console.log('mercadopago: ', response.body)
                  console.log(new Date().getTime())
                  // console.log(this.linkMercadoPago.link)
                  this.linkMercadoPago.link = response.body.init_point
                  // En esta instancia deberás asignar el valor dentro de response.body.id por el ID de preferencia solicitado en el siguiente paso
                  window.location.href = this.linkMercadoPago.link
                })
                .catch(function (error) {
                  console.log('MP ERROR!!!!!')
                  console.log(error)
                })
              this.socio = {
                // nombre: null,
                // apellido: null,
                // estudio_nombre_1: null,
                // estudio_nombre_2: null,
                // email: null,
                // dni: null,
                // toma_clase_regular: null,
                // website: null,
                // telefono: null,
                // celular: null,
                // direccion_1: null,
                // ciudad_1: null,
                // latitude_1: null,
                // longitude_1: null,
                // provincia_id_1: null,
                // pais_id_1: null,
                // ciudad_2: null,
                // direccion_2: null,
                // latitude_2: null,
                // longitude_2: null,
                // provincia_id_2: null,
                // pais_id_2: null,
                // imagen_perfil: null,
                // facebook: null,
                // twitter: null,
                // instagram: null
              }
            } else {
              this.errores = {
                edad: null,
                reincidencia: null,
                toma_clase_regular: null,
                toma_clase_mentoria: null,
                frecuencia_clases_tomadas: null,
                da_clases: null,
                mentoria: null,
                lesiones: null,
                years: null,
                ...respuesta.errors
              }
            }
          })
      }
    }
  },
  mounted: function () {
    this.cargando = true
    asociadoService
      .traerSocioPorId(this.user.persona_id)
      .then(respuesta => {
        this.socio = respuesta
        console.log('Socio:', respuesta)
      })
    asociadoService
      .traerProfesoresFormadores(this.user.persona_id)
      .then(respuesta => {
        // this.cargando = false
        this.profesores = respuesta
        console.log('Profesores:', respuesta)
        this.profesores.map(function (x) {
          return x.item_data = x.nombre + ' ' + x.apellido
        })
      })
    asociadoService
      .traerProfesoresMentores()
      .then(respuesta => {
        // this.cargando = false
        this.profesoresMentores = respuesta
        console.log('Profesores Mentores:', respuesta)
        this.profesoresMentores.map(function (x) {
          return x.item_data = x.nombre + ' ' + x.apellido
        })
      })
    mentorService
      .chequearInscripcionExamenPorPersonaIdPorServicioId(this.user.persona_id, this.servicio_id)
      .then(respuesta => {
        this.cargando = false
        if (respuesta.success) {
          this.mostrarYaEstasInscripto = true
          console.log('Estas inscripto')
        } else {
          mentorService
            .chequearInscripcionCompleta(this.servicio_id) // Valida que no se anoten mas de 24 personas
            .then(respuesta => {
              if (respuesta.success) {
                this.mostrarInscripcionCompleta = true
              } else {
                this.mostrarInscripcionCerrada = true
                this.mostrarForm = false // ya es tarde se paso la fecha
                // this.mostrarForm = true // ya es tarde se paso la fecha
                // mentorService
                //   .checkInscripcionPorMentorPorPersonaId(this.user.persona_id) // Valida que no se anoten mas de 4 x mentor
                //   .then(respuesta => {
                //     if (respuesta.success) {
                //       this.mostrarCupoCompletoPorMentor = true
                //       console.log('cupo completo')
                //     } else {
                //       this.mostrarForm = true
                //     }
                //   })
              }
              console.log('mostrarInscripcionCompleta:', respuesta.success)
            })
        }
      })
  }
}
</script>
<style>

</style>
